import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[width]',
  standalone: true,
  host: {
    '[style.min-width]': 'width',
    '[style.max-width]': 'width',
  }
})
export class WidthDirective {

  @Input({ alias: 'width' }) width: string;
}
